import {ApiRoutesModel} from "@/store/models/layout/api_routes";

export const ApiRoutesModelMixin = {
  computed:{
    route(){
      return this.$route.meta.package
    },
    apiRoutes(){
      return ApiRoutesModel.getRoutePackage(this.route)
    }
  },
  methods:{
    apiCall(){
      const x = this.apiRoutes.map(el=>{
        ApiRoutesModel.getResponseData(el)
        // model.insertOrUpdate({data:response.data[apiEntity]})

      })

    }
  }
}





// WEBPACK FOOTER //
// ./src/mixins/api_routes_model__mixin.js